import { useCallback, useState } from 'react';

//* HOC's
import { withLanguageContext } from '@/context';
import { useCart } from '@weareconceptstudio/cart';

//* Components
import Text from '@/components/common/Text';
import Price from '@/components/common/Price';
import Editor from '@/components/common/Editor';
import Button from '@/components/common/Button';
import Counter from '@/components/common/Counter';
import CustomImage from '@/components/common/Image';
import CustomRate from '@/components/common/CustomRate';

//* Style
import ProductInfoSectionStyle from './style';

const ProductInfoSection = ({ id, name, weight, short_description, tags, price, sale_price, sku, brand, product_information, storage_instruction, shipping_information, translate, average_rating, review_count, stock_status, out_of_stock_message }) => {

	const { toggleCartItem, items } = useCart();
	const isInCart = items.some((item) => Number(item?.product?.id) === Number(id));

	//! States
	const [qty, setQty] = useState(1);
	const [activeTab, setActiveTab] = useState(1);

	//! Handle add to bag
	const handleAddToBag = useCallback(() => {
		return toggleCartItem({ productId: id, qty: qty });
	}, [id, qty, toggleCartItem]);

	return (
		<ProductInfoSectionStyle>
			<Text className={'h2-L font-futura-medium title'}>{name}</Text>

			<CustomRate
				qty={review_count}
				defaultValue={average_rating}
			/>

			<Text
				text={weight}
				className={'h4 font-futura-regular weight'}
			/>

			<Editor data={short_description} />

			<div className='tags-wrap'>
				{tags.map((tag, index) => {
					return (
						<div
							key={index}
							className='tag'
						>
							<CustomImage
								src={tag?.icon?.src}
								alt={tag?.icon?.alt}
							/>

							<Text
								className={'h6 font-futura-regular'}
								text={tag?.name}
							/>
						</div>
					);
				})}
			</div>

			{/* Out of Stock Note */}
			{stock_status === 'outofstock' ? (
				<div className='out-of-stock-note'>
					<Text
						className={'h5 font-futura-medium purple'}
						text={out_of_stock_message || 'outOfStockMessageDefault'}
					/>
				</div>
			) : null}

			<div className={`buy-product-wrap ${stock_status == 'instock' ? 'second-version' : ''}`}>
				<Price
					price={price}
					className={'h3'}
					sale_price={sale_price}
					isSecondVersion
				/>

				{stock_status == 'instock' ? (
					<div className='action-wrap'>
						<Counter onChange={(newCount) => setQty(newCount)} />

						<Button
							hasAdd
							text={'addToBag'}
							className={'add-to-bag'}
							onClick={handleAddToBag}
						/>
					</div>
				) : (
					<Button
						size={'small'}
						btnType={'out-of-stock'}
						text={'outOfStock'}
						className={`out-of-stock`}
						useInfoShow={false}
					/>
				)}
			</div>

			<div className='sku-and-brand-wrap'>
				<Text className={'h5 font-futura-regular'}>
					{translate('sku')}:&nbsp;<span className='darkGrey'>{sku}</span>
				</Text>

				<Text className={'h5 font-futura-regular'}>
					{translate('brand')}:&nbsp;<span className='darkGrey'>{brand.name}</span>
				</Text>
			</div>

			<div className='tabs-wrap'>
				<Text
					text={'productInformation'}
					onClick={() => setActiveTab(1)}
					className={`h5 font-futura-regular tab-label ${activeTab === 1 ? 'active' : ''}`}
				/>

				<Text
					text={'storageInstruction'}
					onClick={() => setActiveTab(2)}
					className={`h5 font-futura-regular tab-label ${activeTab === 2 ? 'active' : ''}`}
				/>

				<Text
					text={'shippingInformation'}
					onClick={() => setActiveTab(3)}
					className={`h5 font-futura-regular tab-label ${activeTab === 3 ? 'active' : ''}`}
				/>
			</div>

			<div className='tabs-content-wrap'>
				<Editor data={activeTab === 1 ? product_information : activeTab === 2 ? storage_instruction : shipping_information} />
			</div>
		</ProductInfoSectionStyle>
	);
};

export default withLanguageContext(ProductInfoSection, ['translate']);
